import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Signal,
  ViewChild,
  effect,
  inject,
} from '@angular/core';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-dayjs-4';
import { getMinMaxDate } from '../../services/assessmentsHistory.functions';
import { AssessmentChartDataRow, AssessmentChartDataSets, SubTestChartDataSet } from '../../services/model';
import { BarChartBaseComponent } from '../bar-chart-base/bar-chart-base.component';

@Component({
  selector: 'app-double-bar-chart',
  standalone: true,
  imports: [],
  template: '<canvas style="width:100%" #canvas [id]="chartId">{{ chart }}</canvas>',
})
export class DoubleBarChartComponent extends BarChartBaseComponent implements OnInit {
  @Input() data!: Array<AssessmentChartDataRow> | undefined;
  @Input() dataFull!: Signal<AssessmentChartDataSets | undefined>;
  @Input() chartId!: string;
  @Input() label!: string;
  @Input() reverse: boolean = false;
  @Input() type!: 'bar' | 'line';
  @ViewChild('canvas', { read: ElementRef, static: true }) canvas!: ElementRef<any>;

  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  private maxY = 19 * 3; // maximal mögliche Punktzahl ist bei 19 Fragen und 3 Punkten je Frage
  constructor() {
    super();
    effect(() => {
      this.dataFull();
      if (this.chart) {
        this.createChart();
        this.cdr.detectChanges();
      }
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.createChart();
      this.cdr.detectChanges();
    }, 50);
  }

  createChart() {
    // jür jedes Datum eine Row
    const dataRows: Array<AssessmentChartDataRow> = this.data ?? [];

    const datasetsObject: AssessmentChartDataSets = this.dataFull() ?? {};
    const { minDate, maxDate, labelDataFull } = getMinMaxDate(datasetsObject);

    // if (this.chartId === 'arat') {
    //   debugger;
    // }

    const data = dataRows.map(row => {
      let score_left = 0;
      let score_right = 0;
      let sum_left = 0;
      let sum_right = 0;
      let unitLabel = '';
      if (this.chartId === 'arat') {
        // const grasp: SubTestChartDataSet = row.subDataSets.filter(set => set.subType === 'grasp')[0];
        // const grip = row.subDataSets.filter(set => set.subType === 'grip')[0];
        // const pinch = row.subDataSets.filter(set => set.subType === 'pinch')[0];
        // const gross = row.subDataSets.filter(set => set.subType === 'gross')[0];
        // const gripSumLeft = grip?.sumLeft ?? 0;
        // const pinchSumLeft = pinch?.sumLeft ?? 0;
        // const graspSumLeft = grasp?.sumLeft ?? 0;
        // const grossSumLeft = gross?.sumLeft ?? 0;
        // sum_left = gripSumLeft + pinchSumLeft + graspSumLeft + grossSumLeft;
        // const gripSumRight = grip?.sumRight ?? 0;
        // const pinchSumRight = pinch?.sumRight ?? 0;
        // const graspSumRight = grasp?.sumRight ?? 0;
        // const grossSumRight = gross?.sumRight ?? 0;
        // sum_right = gripSumRight + pinchSumRight + graspSumRight + grossSumRight;
        unitLabel = 'Punkte';
      }
      if (this.chartId === 'nhpt') {
        // console.log('nhpt...', row.subDataSets);

        // const nhpt: SubTestChartDataSet = row.subDataSets.filter(set => set.subType === 'nhpt')[0];
        // const sum_left = nhpt?.sumLeft ?? 0;
        // const sum_right = nhpt?.sumRight ?? 0;
        unitLabel = 'Sekunden';
      }
      if (this.chartId === 'bbt') {
        unitLabel = 'Blöcke';
      }
      if (this.chartId === 'bbs') {
        unitLabel = 'Punkte';
      }
      row.subDataSets.forEach(subDataSet => {
        // if (this.chartId === 'arat') {
        //   console.log('arat doublebarchart: ' + row.dateIso + ' ' + subDataSet.subType, {
        //     dataL: subDataSet.score_left,
        //     dataR: subDataSet.score_right,
        //   });
        // }
        const leftnew = subDataSet.score_left ?? 0;
        const rightnew = subDataSet.score_right ?? 0;
        if (leftnew > score_left) {
          score_left = leftnew;
        }
        if (rightnew > score_right) {
          score_right = rightnew;
        }
        const leftValue = subDataSet.sumLeft ?? 0;
        const rightValue = subDataSet.sumRight ?? 0;
        sum_left = sum_left + leftValue;
        sum_right = sum_right + rightValue;
      });
      // const dataset: SubTestChartDataSet = row.subDataSets[0];
      return {
        x: new Date(new Date(row.dateIso).toDateString()),
        dataL: score_left,
        dataR: score_right,
        score: row.score,
        tooltipLabelL: ` ${score_left} %  (${sum_left} ${unitLabel}) `,
        tooltipLabelR: ` ${score_right} %  (${sum_right} ${unitLabel}) `,
        documentId: row.documentId,
        assessmentType: row.type,
      };
    });
    // if (this.chartId === 'arat') {
    //   console.log('arat doublebarchart: ', { date: data[2].x, dataL: data[2].dataL, dataR: data[2].dataR });
    // }

    const datasets = [
      {
        label: 'links',
        data: data,
        minBarLength: 2,
        parsing: {
          yAxisKey: 'dataL',
        },
        categoryPercentage: data.length < 4 ? 0.3 : 0.7,
        barPercentage: 1.0,
      },
      {
        label: 'rechts',
        data: data,
        minBarLength: 2,
        parsing: {
          yAxisKey: 'dataR',
        },
        categoryPercentage: data.length < 4 ? 0.3 : 0.7,
        barPercentage: 1.0,
      },
    ];

    if (this.chart) {
      this.chart.data = { labels: labelDataFull, datasets: datasets };
      this.chart.options.scales.x.min = minDate;
      this.chart.options.scales.x.max = maxDate;
      this.chart.update();
    } else {
      this.chart = new Chart(
        this.canvas.nativeElement,
        this.getChartConfig(datasets, minDate, maxDate, labelDataFull, this.reverse, 100)
      );
    }
  }
}
